import type { ComponentPropsWithoutRef, ReactNode } from "react";

export type DateInputItemProps = {
	title: ReactNode;
	warning?: ReactNode;
} & Omit<ComponentPropsWithoutRef<"input">, "type">;

export const DateInputItem = ({
	title,
	warning,
	className = "field-item__input",
	...inputProps
}: DateInputItemProps) => (
	<div className='form__fields_field-item field-item'>
		<div className='field-item__title'>{title}</div>
		<div className='field-item__input-wrapper'>
			<input type='date' className={className} {...inputProps} />
			{warning ? (
				<div className='field-item__warning'>
					<div>{warning}</div>
				</div>
			) : null}
		</div>
	</div>
);
